import {Component, Input} from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-text-window',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './text-window.component.html',
  styleUrl: './text-window.component.scss'
})
export class TextWindowComponent {
  @Input() title: string = 'Default Title';
  @Input() content: string = 'This is the default content.';
  isVisible: boolean = true;

  close() {
    this.isVisible = false;
  }
}
